"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const availablebrand01 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 71 70",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-availablebrand01` : '') + (description ? ` desc-availablebrand01` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-availablebrand01"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-availablebrand01"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.286 37.143C5.286 55.289 19.996 70 38.143 70 56.289 70 71 55.29 71 37.143S56.29 4.286 38.143 4.286 5.286 18.996 5.286 37.143Z",
    fill: "#FFC599",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 33.857C0 15.158 15.158 0 33.857 0c18.699 0 33.857 15.158 33.857 33.857 0 18.699-15.158 33.857-33.857 33.857C15.158 67.714 0 52.556 0 33.857ZM33.857 2C16.263 2 2 16.263 2 33.857s14.263 31.857 31.857 31.857 31.857-14.263 31.857-31.857S51.451 2 33.857 2Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6 26.649 30.84 43.943l-8.585-9.599 1.49-1.333 7.06 7.892 13.273-15.552 1.522 1.298Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = availablebrand01;